import { render } from "./portabout.vue?vue&type=template&id=4dbaff4f"
import script from "./portabout.vue?vue&type=script&lang=js"
export * from "./portabout.vue?vue&type=script&lang=js"

import "./portabout.vue?vue&type=style&index=0&id=4dbaff4f&lang=scss"

import exportComponent from "C:\\laragon\\www\\juani\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__